import { useCallback, useEffect, useState } from "react";
import { useAppDispatch } from "../../../store";
import { requestPasswordChange } from "../../../acions/auth";
import { ISSUE_WITH_ACCOUNT } from "../../../lib/constants";

export const useSendEmail = (userName: string) => {
  const dispatch = useAppDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [hasAccountIssues, setIsHasAccountIssues] = useState<boolean>(false);

  const sendEmail = useCallback(async () => {
    try {
      setIsLoading(true);

      await Promise.resolve(dispatch(requestPasswordChange({ userName })));

      setIsLoading(false);
    } catch (e: any) {
      setIsLoading(false);

      if (e.response.data.title === ISSUE_WITH_ACCOUNT) {
        setIsHasAccountIssues(true);
      }
    }
  }, [dispatch, setIsHasAccountIssues, userName]);

  useEffect(() => {
    sendEmail();
  }, [sendEmail]);

  return { isLoading, hasAccountIssues, sendEmail };
};
